import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import noop from 'lodash/noop'
import rem from 'utils/rem'
import PricingFormulaRow from './PricingFormulaRow'
import PricingTableCell from './PricingTableCell'

const PricingFormulaTable = ({ isViewMode, control, watch, setValue, priceEntry, isPricelist }) => {
  const { defaultYardUm, settings } = useSelector(state => state.settings)
  const { disableUmDropdowns } = settings?.purchaseSettings?.inboundTickets || {}

  return (
    <table style={{ borderCollapse: 'collapse' }} width="100%" cellSpacing={0} cellPadding={0}>
      <tbody>
        <tr style={{ borderBottom: '1px solid grey' }}>
          <PricingTableCell width="8%" textAlign="center">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              Price Type
            </Typography>
          </PricingTableCell>
          <PricingTableCell width="10%" textAlign="center">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              Formula?
            </Typography>
          </PricingTableCell>
          <PricingTableCell width="15%" textAlign="left">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              (Reference Price
            </Typography>
          </PricingTableCell>
          <PricingTableCell width="10%" textAlign="center">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              - Differential)
            </Typography>
          </PricingTableCell>
          <PricingTableCell width="9%" textAlign="center">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              x Recovery
            </Typography>
          </PricingTableCell>
          <PricingTableCell width="10%" textAlign="center">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              - Other Costs
            </Typography>
          </PricingTableCell>
          <PricingTableCell width="10%" textAlign="left">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              = Price
            </Typography>
          </PricingTableCell>
          {disableUmDropdowns ? null : (
            <PricingTableCell width="8%" textAlign="left">
              <Typography fontWeight="bold" fontSize={rem(14)}>
                UM
              </Typography>
            </PricingTableCell>
          )}
          <PricingTableCell width="8%" textAlign="center">
            <Typography fontWeight="bold" fontSize={rem(14)}>
              Min/Max Range
            </Typography>
          </PricingTableCell>
        </tr>
        <PricingFormulaRow
          isViewMode={isViewMode}
          control={control}
          watch={watch}
          isBuy
          setValue={setValue}
          priceEntry={priceEntry}
          isPricelist={isPricelist}
          tradePrice={priceEntry.buyPrice}
          priceEntryUnits={priceEntry?.weightUnits || priceEntry?.units || defaultYardUm}
          materialTypeId={priceEntry.materialTypeId}
        />
        {!isPricelist && (
          <PricingFormulaRow
            isViewMode={isViewMode}
            control={control}
            watch={watch}
            setValue={setValue}
            priceEntry={priceEntry}
            isPricelist={isPricelist}
            tradePrice={priceEntry.sellPrice}
            priceEntryUnits={priceEntry?.weightUnits || priceEntry?.units || defaultYardUm}
            materialTypeId={priceEntry.materialTypeId}
          />
        )}
      </tbody>
    </table>
  )
}

PricingFormulaTable.propTypes = {
  isViewMode: PropTypes.bool,
  control: PropTypes.object,
  watch: PropTypes.func,
  setValue: PropTypes.func,
  priceEntry: PropTypes.object,
  isPricelist: PropTypes.bool,
}

PricingFormulaTable.defaultProps = {
  isViewMode: false,
  control: {},
  watch: noop,
  setValue: noop,
  priceEntry: {},
  isPricelist: false,
}

export default PricingFormulaTable
